import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["billId"];
import { api } from 'src/api';
import { types } from 'mobx-state-tree';
import { createAsync } from 'src/utils/asyncModel';
const startBillAsync = createAsync(body => {
  return async function startBill(options) {
    const resp = await api.BillAutomationBills.startBill(body, options);
    return resp;
  };
});
const getBillAsync = createAsync(billId => {
  return async function getBill(options) {
    const resp = await api.BillAutomationBills.getBill(billId, options);
    return resp;
  };
});

/**
 * Pushes one uploaded bill to AppFolio AP. Resolves with the attempts the service created.
 * `overrideTotalAmount` is present only when a person edited the Bill total by hand, and
 * `invoiceNumber` only when they supplied one the extraction could not.
 */
const pushBillToAppfolioAsync = createAsync(body => {
  return async function pushBillToAppfolio(options) {
    const billId = body.billId,
      supplied = _objectWithoutProperties(body, _excluded);
    const resp = await api.BillAutomationBills.pushBillToAppfolio(billId, supplied, options);
    return resp;
  };
});

/** AppFolio AP push status for a batch of bills, so the dashboard can refresh several rows at once. */
const getAppfolioPushStatusAsync = createAsync(body => {
  return async function getAppfolioPushStatus(options) {
    const resp = await api.BillAutomationBills.getAppfolioPushStatus(body, options);
    return resp;
  };
});
const BillAutomationBillsApiStore = types.model('BillAutomationBillsApiStore', {
  startBillAsync,
  getBillAsync,
  pushBillToAppfolioAsync,
  getAppfolioPushStatusAsync
});
export const billAutomationBillsApi = types.optional(BillAutomationBillsApiStore, {});